import { Observable } from 'rxjs';
import { ApiService, CREATE_RATING_PATH, CreateRatingBody } from '@core-http';

export class RatingService extends ApiService {
  rateApplication(payload: CreateRatingBody): Observable<void> {
    return this.httpClient.post<void>(`${this.env.apiUrl}${CREATE_RATING_PATH}`, payload);
  }
}
